import { isEqual } from 'lodash';
import Image from 'next/image';

import { ProductCategoryModel } from '../../../interface/products';
import { SUBZERO_BRAND_NAME } from '../../../constants/brands';
import CustomButton from '../../atoms/custom-button/custom-button';

/* eslint-disable-next-line */
type CategoryRowProps = {
  brandTitle: string;
  category: ProductCategoryModel;
  ctaLink: string;
  imageAlignment: 'left' | 'right';
};

export function CategoryRow(props: CategoryRowProps) {
  const { brandTitle, category, ctaLink, imageAlignment } = props;

  const hoverColor = isEqual(brandTitle, SUBZERO_BRAND_NAME)
    ? 'hover:bg-primaryBlue'
    : 'hover:bg-primaryRed';

  const leftImage = isEqual(imageAlignment, 'left') && (
    <Image
      alt="category image"
      blurDataURL="/icons/blur-placeholder.png"
      height={'100%'}
      layout="responsive"
      placeholder="blur"
      src={category.categoryImage.data.attributes.url}
      width={'50%'}
    />
  );

  const rightImage = isEqual(imageAlignment, 'right') && (
    <Image
      alt="category image"
      height={'100%'}
      layout="responsive"
      src={category.categoryImage.data.attributes.url}
      width={'50%'}
    />
  );

  return (
    <div className="w-full h-[400px] grid grid-cols-2">
      {leftImage}
      <div
        className={`flex flex-col justify-center items-start px-6 lg:px-12 bg-categoryCardGray hover:text-white group ${hoverColor}`}
      >
        <p className="text-header6 lg:text-header5 font-MuseoSans300">
          {category.categoryTitle}
        </p>
        <p className="text-subtitle leading-6 mt-2 group-hover:text-white">
          {category.categoryDescription}
        </p>
        <div className="flex w-full justify-end">
          <CustomButton
            buttonText="Explore Range &gt;"
            buttonStyle="bg-transparent"
            ctaLink={ctaLink}
            hasLink
            textStyle="mt-4 py-3 text-body uppercase text-body group-hover:text-white border-black group-hover:border-white"
          />
        </div>
      </div>
      {rightImage}
    </div>
  );
}

export default CategoryRow;
